import {ViewType} from "../../core/gd/const/views/view-type";
import {NavigationButtonPosition} from "../../core/model2/navigation/@const";

export const MAIN_MENU_DEFAULT_WIDTH        = 225
export const MAIN_MENU_POPOVER_MIN_WIDTH    = 255


export const BUS_NAVIGATION_CHANGED   = 'navigation:settings-changed'
export const BUS_MAIN_MENU_OUTSIDE_CLICK   = 'main-menu:outside-click'


export enum NavigationButtonTypeClass {
    IS_TAB      = "is-tab",
    IS_BUTTON   = "is-button",
}


export const PersonalViewsWithMainMenu = [
    ViewType.MY_TASKS_LIST,
    ViewType.MY_GOALS,
]



export const OptionNavigationPanelBottom : Option = {
    label       : 'Navigation panel',
    icon        : 'i5-panel',
    value       : NavigationButtonPosition.BOTTOM
}

export const OptionNavigationPanelTop : Option = {
    label       : 'Navigation panel',
    value       : NavigationButtonPosition.TOP,
    icon        : 'i5-panel',
}

export const OptionNavigationPanelMore : Option = {
    label       : 'More menu',
    value       : NavigationButtonPosition.MORE,
    icon        : 'i5-more',
}